import { lazy } from 'react'

export const ScheduledTasks = lazy(() => import('@/client/scheduled'))
